function loginIn() {
  const redirectUri = encodeURIComponent(
    location.href
  )
  var loginUrl = window.$config.loginUrl + '?',
    activityCode = window.$config.activityCode,
    code = sessionStorage.getItem('code'),
    channelId = sessionStorage.getItem('channelId')
  // 官网跳到电商的地址里带有channel_Id，去注册的时候，直接让注册取cookie里的channel_Id就可以（默认操作）
  // 如果没有带channel_Id，也就是session里未存储有channelId，或者携带了，但是是自然流量，就判断是否在url上有fr这个参数（fr是活动code）
  if (!channelId || channelId === 156) {
    // 登录的页面也有注册功能，如果session里没有存储从url带过来的activityCode，那么带上电商的渠道
    if (!code) {
      loginUrl += `appId=10003&activityCode=${activityCode}&`
    } else {
      loginUrl += `appId=10003&activityCode=${code}&`
    }
  }
  
  location.href = loginUrl + `redirect_uri=${redirectUri}`
}
function apply() {
  var applyUrl = window.$config.applyUrl,
    activityCode = window.$config.activityCode,
    code = sessionStorage.getItem('code'),
    channelId = sessionStorage.getItem('channelId')
  // 官网跳到电商的地址里带有channel_Id，去注册的时候，直接让注册取cookie里的channel_Id就可以（默认操作）
  // 如果没有带channel_Id，也就是session里未存储有channelId，或者携带了，但是是自然流量，就判断是否在url上有fr这个参数（fr是活动code）
  if (!channelId || channelId === 156) {
     // 注册时，如果session里没有存储从url带过来的activityCode或者是自然流量156，那么带上电商的渠道
    if (!code) {
      applyUrl += `?appId=10003&activityCode=${activityCode}`
    } else {
      applyUrl += `?appId=10003&activityCode=${code}`
    }
  }
  location.href = applyUrl
}
export {
  loginIn,
  apply
}